import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './CategoryCards.css';
// @ts-ignore
import BackToTop from './BackToTop'; // Fixed casing in the import

// Import your images
import nightVisionImage from '../assets/images/AnotherNightVisionPic.webp';
import thermalImage from '../assets/images/Thermal.jpg.webp';
import circuitBoardImage from '../assets/images/circuit-board.jpg.avif'; // You'll need this image or equivalent

const CategoryCards = () => {
    const [hoveredCard, setHoveredCard] = useState(null);

    const categories = [
        {
            id: 'night-vision',
            title: 'Night Vision',
            image: nightVisionImage,
            link: '/solutions/night-vision'
        },
        {
            id: 'thermal',
            title: 'Thermal',
            image: thermalImage,
            link: '/solutions/thermal'
        },
        {
            id: 'more',
            title: 'More',
            image: circuitBoardImage,
            link: '/solutions'
        }
    ];

    return (
        <div className="category-section">
            <div className="category-cards-container">
                {categories.map(category => (
                    <Link 
                        to={category.link} 
                        key={category.id}
                        className={`category-card ${hoveredCard === category.id ? 'hovered' : ''}`}
                        onMouseEnter={() => setHoveredCard(category.id)}
                        onMouseLeave={() => setHoveredCard(null)}
                        style={{ backgroundImage: `url(${category.image})` }}
                    >
                        <div className="category-overlay"></div>
                        <h2 className="category-title">{category.title}</h2>
                    </Link>
                ))}
            </div>
            {/* The BackToTop component */}
            <div className="back-to-top-container">
                <BackToTop />
            </div>
        </div>
    );
};

export default CategoryCards;